<template>
  <div>
    <validation-provider
      :name="$t(`commands.form.${config.name}.label`)"
      :rules="config.rules ? config.rules : {}"
      v-slot="{ errors }"
      v-if="showField"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <template v-if="isTextArea">
        <textarea
          v-model="model"
          class="form-control"
          @input="$emit('input', model)"
          rows="4"
        >
        </textarea>
      </template>
      <input
        v-else-if="isNumeric"
        type="number"
        step="any"
        min="0"
        v-model="model"
        class="form-control"
        @input="$emit('input', model)"
      />
      <v-select
        v-else-if="isSelect"
        :options="selectOptions"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.value"
        input-id="option-id"
        :multiple="false"
        @input="$emit('input', model)"
      />
      <input
        v-else
        type="text"
        v-model="model"
        class="form-control"
        @input="$emit('input', model)"
      />
      <p v-if="hint" class="mb-0 small">{{ $t(hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>

import {ValidationProvider} from "vee-validate";
import vSelect from 'vue-select';

export default {
  name: "InputField",
  components: {
    ValidationProvider,
    vSelect,
  },
  props: {
    value: {
      type: String | Number,
    },
    nodeInfo: Object,
    config: Object,
    context: Object,
    type: String,
  },
  data() {
    return {
      model: null,
      selectOptions: [],
    };
  },
  created() {
    this.model = this.value ? this.value : this.defaultValue;
    this.$nextTick(() => this.$emit('input', this.model));
  },
  mounted() {
    if (this.context.command === 'update_alarm_status_command') {
      this.selectOptions = [
        {value: 'waiting', label: 'Waiting'},
        {value: 'attending', label: 'Attending'},
      ];
    }
  },
  computed: {
    hint() {
      return this.config.hint || null;
    },
    defaultValue() {
      if (this.nodeInfo.name === 'alarm_image_inference') {
        return "Describe the image clearly and directly. Mention only the relevant details without adding unnecessary information or recommendations. Focus on the main elements and any important details that add value to the description";
      }

      return this.config.default || null;
    },
    isTextArea() {
      if (!this.config) {
        return false;
      }

      return this.config.subtype === 'textarea';
    },
    isNumeric() {
      if (!this.config) {
        return false;
      }

      return this.config.subtype === 'numeric';
    },
    isSelect() {
      if (!this.config) {
        return false;
      }

      return this.config.subtype === 'select';
    },
    showField() {
      if (this.context.command === 'update_alarm_status_command' && this.isSelect) {
        return this.context.model.alarm_status === 'remove_maker_checker_flow';
      }

      // Others validations...
      return true;
    },
  }
};
</script>

<style></style>
